/**
 * @generated SignedSource<<d23f941d77e2d7ed802f2ef990fd62f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenInviteDialog_event$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "EventScreenInviteDialog_event";
};
export type EventScreenInviteDialog_event$key = {
  readonly " $data"?: EventScreenInviteDialog_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenInviteDialog_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenInviteDialog_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "fb2e82b8a6f9216fbfc6783878072afb";

export default node;
